import { Component, forwardRef } from '@angular/core';
import { PlatformApiService } from '../../services/platform-api.service';
import { SessionService } from 'src/app/services/session.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { User} from '../../models/AccountModel';
import { WizardScreenComponent } from 'src/app/shared/wizard.component';

@Component({
  selector: 'cw-ci-profile-info',
  templateUrl: './profile-info.component.html',
  styleUrls: ['./profile-info.component.scss'],
  providers: [{provide: WizardScreenComponent, useExisting: forwardRef(() => ProfileInfoComponent)}]
})
export class ProfileInfoComponent extends WizardScreenComponent {
  private usr: User = null;

  constructor(private _sessionService: SessionService, private _apiService: PlatformApiService) {
    super();
    this.form = new FormGroup ({
      firstName: new FormControl('', [Validators.required]),
      lastName: new FormControl('', [Validators.required]),
      email: new FormControl('', [Validators.required])
    });
  }

  onLoad() {
    this.form.reset();
    this.showSpinner()
    this._apiService.getAccountUser(this._sessionService.getCurrentAccount().id, this._sessionService.getCurrentUser().id).subscribe(
      usr=> {
        this.usr = usr;
        this.form.controls.firstName.setValue(usr.firstName);
        this.form.controls.lastName.setValue(usr.lastName);
        this.form.controls.email.setValue(usr.email);
        this.hideSpinner()
        super.onLoad();
      }
    );
  }

  onSave() {
    if (this.isValid()) {
      this.showSpinner('Saving...');

      this.usr.firstName = this.form.controls.firstName.value;
      this.usr.lastName = this.form.controls.lastName.value;

      this._apiService.saveAccountUser(this._sessionService.getCurrentAccount().id, this.usr).subscribe(user => {
        this.hideSpinner()
        super.onSave();
      }, err => {
        // TODO emit error message
        console.log('Failed to save user', err);
        this.hideSpinner()
      });
    }
  }
}